import { useCallback } from 'react'

import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'

import { IconsList } from './IconsList'

import styles from './IconModalDialog.module.scss'

interface IIconModalDialog {
  onChange: (icon: string) => void
  visible: boolean
  onClose: () => void
}

export const IconModalDialog = ({ onChange, visible, onClose }: IIconModalDialog) => {
  const changeIcon = useCallback(
    (icon: string) => {
      onChange(icon)
      onClose()
    },
    [onChange, onClose]
  )

  return (
    <ModalDialog
      size={'sm'}
      show={visible}
      onClose={onClose}
      content={() => {
        return (
          <div>
            <Button
              className={styles.clearButton}
              onClick={() => changeIcon('')}
              iconButton={'kbase kbase-delete'}
              color={'danger'}
              __testId={'IconModal__clear-button'}
            >
              Clear
            </Button>
            <IconsList onChange={changeIcon} />
          </div>
        )
      }}
    />
  )
}
